import {
  TOGGLE_UNBOUNCE_MODAL,
  SUBMIT_UNBOUNCE,
  SUBMIT_UNBOUNCE_SUCCESS,
  SUBMIT_UNBOUNCE_FAIL,
} from "../actionTypes";

const initialState = {
  unbounceModalShow: false,
  isSubmitted: false,
  isSubmitting: false,
};

function unBounceModalReducer(state = initialState, { type }) {
  switch (type) {
    case TOGGLE_UNBOUNCE_MODAL:
      return { ...state, unbounceModalShow: !state.unbounceModalShow };

    case SUBMIT_UNBOUNCE:
      return { ...state, isSubmitting: true };
    case SUBMIT_UNBOUNCE_SUCCESS:
      return { ...state, isSubmitted: true, isSubmitting: false };
    case SUBMIT_UNBOUNCE_FAIL:
      return { ...state, isSubmitted: false, isSubmitting: false };
    default:
      return state;
  }
}

export default unBounceModalReducer;
